<template>
  <div class="index">
    <vuescroll :ops="vuescrollOption">
      <banner></banner>
      <div class="content">
        <div class='breadcrumb'>
          <div class="left">
            您目前的位置：<router-link to="/index">首頁</router-link>> <router-link to="/list">公告</router-link>> {{article.title}}
          </div>
          <div class="right">
            <router-link to="/index">
              <img src="@/assets/images/article/returnHome.png">
            </router-link>
          </div>
        </div>
        <div class='titleDiv'>
          <div class="title">
            {{article.title}}
          </div>
          <div class="time">
            {{article.date}}
          </div>
        </div>
        <div class='contentText' v-html='article.content'>
        </div>
      </div>
      <foot></foot>
    </vuescroll>
  </div>
</template>

<script>
import vuescroll from 'vuescroll';
import banner from '@/components/banner';
import foot from '@/components/foot';
import axios from 'axios';
export default {
  name: 'index',
  components:{
    vuescroll,banner,foot
  },
  data () {
    return {
      vuescrollOption:{
        scrollPanel: {
          initialScrollY: 6.7*parseFloat(document.documentElement.style.fontSize),
        },
      },
      article:{
        title:'',
        date:'',
        content:'',
      }
    }
  },
  mounted(){
    // let x=window.innerWidth;
    // document.documentElement.style.fontSize = x/19.2+"px";
    let id=this.$route.query.id?this.$route.query.id:1;
    this.getArticl(id);
  },
  methods:{
    goPage(href){
      window.location.href=href;
    },
    getArticl(id){
      axios.get('./static/article/'+id+'.json').then((res)=>{
        this.article.title=res.data.title;
        this.article.date=res.data.date;
      })
      axios.get('./static/article/'+id+'.html').then((res)=>{
        this.article.content=res.data;
      })
    }
  },
  computed:{
    articleID(){
      return this.$route.query.id;
    }
  },
  watch:{
    articleID(val) {
      this.getArticl(val);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  table{
    border: solid .01rem #ebebeb;
    width:19.2rem - 6.4rem - 2rem;
  }
  td{
    border: solid .01rem #ebebeb;
    margin:0;
    padding:.07rem;
  }
</style>
<style scoped lang='less'>
@fullWidth:19.2rem;

@bannerHeight:872/100rem;
@contectHeight:2162/100rem;
@footHeight:174/100rem;

@googleBTWidth:326/100rem;
@iphoneBTWidth:262/100rem;
@downloadGaps:.5rem;

@newWidth:48/100rem;

@marqueImgWidth:1200/100rem;
.index{
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  overflow: hidden;
  .banner{
    position: relative;
    width: @fullWidth;
    height: @bannerHeight;
    .bg{
      position: absolute;
      width: @fullWidth;
      left: 0;
      top: 0;
    }
    .downloadBT{
      position: absolute;
      width: @googleBTWidth + @iphoneBTWidth + @downloadGaps;
      left: (@fullWidth - (@googleBTWidth + @iphoneBTWidth + @downloadGaps))/2;
      top: 5.7rem;
      .googleBT{
        position: absolute;
        width: @googleBTWidth;
        right: 0;
        top: 0;
      }
      .iphoneBT{
        position: absolute;
        width: @iphoneBTWidth;
        left: 0;
        top: 0;
      }
    }
  }
  .content{
    margin-left: 3.2rem;
    width: @fullWidth - 6.4rem;
    .breadcrumb{
      margin-top: .35rem;
      margin-bottom: .74rem;
      height:.42rem;
      .left{
        float: left;
        line-height:.42rem;
        font-size:.24rem
      }
      .right{
        float: right;
        font-size:0rem;
        img{
          width:1.32rem;
        }
      }
      a{
        color:#f56b85;
      }
    }
    .titleDiv{
      width:100%;
      height:1.66rem;
      border-top:solid .02rem #ebebeb;
      border-bottom:solid .02rem #ebebeb;
      .title{
        width:100%;
        height:.36rem;
        line-height:.36rem;
        font-size:.36rem;
        color:#ec4828;
        text-align: center;
        margin-top:.5rem;
      }
      .time{
        width:100%;
        height:.24rem;
        line-height:.24rem;
        font-size:.24rem;
        color:#68696b;
        text-align: center;
        margin-top:.18rem;
      }
    }
    .contentText{
      width:@fullWidth - 6.4rem - 2rem;
      line-height:.3rem;
      font-size:.24rem;
      color:#68696b;
      margin-left: 1rem;
      margin-top: .8rem;
      margin-bottom: .8rem;
    }
  }
  .foot{
    position: relative;
    width: @fullWidth;
    height: @footHeight;
    .article{
      position: absolute;
      width: .6rem;
      height:.3rem;
      left:11.4rem;
      top:1.1rem;
      cursor:pointer;
      // background:red;
    }
    .article1{
      position: absolute;
      width: .85rem;
      height:.3rem;
      left:12.2rem;
      top:1.1rem;
      cursor:pointer;
      // background:blue;
    }
    .article2{
      position: absolute;
      width: .85rem;
      height:.3rem;
      left:13.17rem;
      top:1.1rem;
      cursor:pointer;
      // background:yellow;
    }
    .article3{
      position: absolute;
      width: .85rem;
      height:.3rem;
      left:14.2rem;
      top:1.1rem;
      cursor:pointer;
      // background:green;
    }
    .bg{
      position: absolute;
      width: @fullWidth;
      left: 0;
      top: 0;
    }
    .logoLeft{
      position: absolute;
      width: 3.38rem;
      left: 3.2rem;
      top: .17rem;
    }
    .logoRight{
      position: absolute;
      width: 5.4rem;
      right: 3.2rem;
      top: .17rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/article.vue